export enum BackendActionTypes {

    API_RESPONSE_SUCCESS = '@@backend/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@backend/API_RESPONSE_ERROR',

    GET_NODE_ENV_VARIABLES = '@@backend/LOGIN_USER',
    GET_NODE_BOILERPLATE = '@@backend/LOGOUT_USER',
}
